import { Card, CardFooter } from "@/components/ui/Card";

export const Skeleton = ({ className = "" }) => <div className={`animate-pulse bg-gradient-to-r from-gray-700 via-gray-600 to-gray-700 rounded-md ${className}`} />;

export const JobCardSkeleton = () => {
  return (
    <Card className="bg-background-secondary border border-border-primary/65 rounded-md p-5">
      {/* Top Section */}
      <div className="flex justify-between items-start">
        {/* Left Content */}
        <div className="w-full">
          {/* Title + Status */}
          <div className="flex items-center gap-5">
            <Skeleton className="h-6 w-48" />
            <Skeleton className="h-7 w-20 rounded-full" />
          </div>

          {/* Description */}
          <div className="mt-3 space-y-2 max-w-2xl">
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-5/6" />
          </div>

          {/* Applicants & Deadline */}
          <div className="flex gap-5 mt-4">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-32" />
          </div>
        </div>

        {/* Right Actions */}
        <div className="flex items-center gap-2 ml-4">
          <Skeleton className="h-6 w-14" />
          <Skeleton className="h-6 w-14" />
          <Skeleton className="h-7 w-20 rounded-full" />
        </div>
      </div>

      {/* Skills */}
      <div className="flex flex-wrap gap-2 mt-5">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="h-6 w-20 rounded-md" />
        ))}
      </div>

      {/* Footer */}
      <CardFooter className="p-0 mt-5 pt-4 border-t border-border-primary/65">
        <div className="flex justify-between items-center w-full">
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-4 w-4" />
        </div>
      </CardFooter>
    </Card>
  );
};

export const ViewJobSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* Basic Information */}
      <div className="pb-3">
        <Skeleton className="h-5 w-36 mb-4" />
        <div className="grid grid-cols-3 gap-4">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3">
              <Skeleton className="w-10 h-10 rounded-xl flex-shrink-0" />
              <div className="space-y-1.5">
                <Skeleton className="h-3 w-16" />
                <Skeleton className="h-4 w-24" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Skills */}
      <div className="pb-1">
        <Skeleton className="h-5 w-32 mb-4" />
        <div className="flex flex-wrap gap-2">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-6 w-20 rounded-lg" />
          ))}
        </div>
      </div>

      {/* Role Overview */}
      <div className="pb-1">
        <Skeleton className="h-5 w-32 mb-4" />
        <div className="space-y-2">
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-4/5" />
          <Skeleton className="h-3 w-3/5" />
        </div>
      </div>

      {/* Key Responsibilities */}
      <div className="pb-1">
        <Skeleton className="h-5 w-44 mb-4" />
        <div className="space-y-2 pl-5">
          {Array.from({ length: 4 }).map((_, i) => (
            <Skeleton key={i} className="h-3 w-3/4" />
          ))}
        </div>
      </div>
    </div>
  );
};
